import { Paper, Typography, TextField, Tabs, Tab, Tooltip } from '@material-ui/core';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Chart from 'components/Chart';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import Spin from 'components/Spin';
import Truncate from 'components/Truncate';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bestsellers } from 'store/Orbita/Dashboard/actions';

import chartColors from '../../chartOptions';
import styles from '../../styles';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  id: string;
  isFetching: boolean;
  producer: any;
  coproducer: any;
  affiliate: any;
}

class DoughnutChart extends Component<IProps, any> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      data: '',
      legends: '',
      values: '',
      tab: 0,
      date: '1',
    };
  }

  componentDidMount() {
    (async () => {
      try {
        await this.props.dispatch(bestsellers('7'));
        this.setGraphData(0);
      } catch (error) {
        //toast.error('Ops, erro no gráfico de conteúdos mais vendidos');
      }
    })();
  }

  onChangeDate = (op: any) => {
    const option = op.target.value;
    let days;
    switch (option) {
      case '1':
        days = '7';
        break;
      case '2':
        days = '30';
        break;
      case '3':
        days = false;
        break;
      default:
        days = '7';
        break;
    }
    (async () => {
      try {
        await this.props.dispatch(bestsellers(days));
        this.setGraphData(this.state.tab);
      } catch (error) {
        //toast.error('Ops, erro no gráfico de conteúdos mais vendidos');
      }
    })();
    this.setState({ date: option });
  };

  handleChange = (event: any, tab: any) => {
    this.setGraphData(tab);
  };

  setGraphData = (option: any) => {
    const { producer, coproducer, affiliate } = this.props;
    let newData, name;
    switch (option) {
      case 1:
        newData = coproducer;
        name = 'Coprodutor';
        break;
      case 2:
        newData = affiliate;
        name = 'Afiliado';
        break;
      case 0:
      default:
        newData = producer;
        name = 'Produtor';
    }

    this.setState({
      data: {
        labels: newData && newData.labels,
        datasets: [
          {
            label: name,
            backgroundColor: [
              chartColors.red.background,
              chartColors.orange.background,
              chartColors.yellow.background,
              chartColors.green.background,
              chartColors.blue.background,
              chartColors.purple.background,
              chartColors.grey.background,
            ],
            data: newData && newData.data,
            values: newData && newData.values,
            fill: 'start',
          },
        ],
      },
      tab: option,
    });
  };

  render() {
    const options = {
      responsive: true,
      legend: {
        display: false,
      },
    };
    const { classes, isFetching, id } = this.props;
    const { tab, data } = this.state;
    return (
      <Paper square={false} elevation={1} classes={{ root: classes.paper }}>
        <div className={classes.smallCard}>
          {isFetching ? (
            <Spin />
          ) : (
            <div>
              <div className={classes.cardHead}>
                <Typography variant='h6'>Conteúdos mais vendidos</Typography>
                <TextField
                  id='select-currency-native'
                  select
                  label=''
                  SelectProps={{ native: true }}
                  InputProps={{ disableUnderline: true }}
                  className={classes.textField}
                  value={this.state.date}
                  onChange={this.onChangeDate}
                >
                  <option value={1}>7 dias</option>
                  <option value={2}>30 dias</option>
                  <option value={3}>Todos</option>
                </TextField>
              </div>
              <div className={classes.cardTab}>
                <Tabs value={tab} onChange={this.handleChange} classes={{ root: classes.tabsRoot2, indicator: classes.tabsIndicator2 }} centered>
                  <Tab classes={{ root: classes.tabRoot2 }} label={'Produtor'} />
                  <Tab classes={{ root: classes.tabRoot2 }} label={'Co-Produtor'} />
                  <Tab classes={{ root: classes.tabRoot2 }} label={'Afiliado'} />
                </Tabs>
              </div>
              <div className={classes.cardContent}>
                {data && data.labels && data.labels && Array.isArray(data.labels) && data.labels.length > 0 ? (
                  <div>
                    <div className={classes.cardGraph}>
                      <Chart id={id} type='doughnut' options={options} data={this.state.data} />
                    </div>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell align='left'>Conteúdo</TableCell>
                          <TableCell align='right'>Qtd</TableCell>
                          <TableCell align='right'>Ganho</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {Array.isArray(data?.labels) &&
                          data.labels.map((item: string, i: number) => (
                            <TableRow key={item}>
                              <TableCell component='th' scope='row'>
                                <div
                                  key={'product-list-' + i}
                                  style={{
                                    borderLeft: '5px solid ' + data.datasets[0]['backgroundColor'][i],
                                    paddingLeft: 8,
                                  }}
                                >
                                  <Tooltip title={item.length > 30 ? item : ''} placement='top' arrow>
                                    <span>
                                      <Truncate count={30} final='...'>
                                        {item}
                                      </Truncate>
                                    </span>
                                  </Tooltip>
                                </div>
                              </TableCell>
                              <TableCell>{data.datasets[0].data[i]}</TableCell>
                              <TableCell>
                                <ColoredFormattedNumber value={data.datasets[0].values[i]} />
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </div>
                ) : (
                  <div style={{ textAlign: 'center' }} className={classes.cardGraph}>
                    <span> Não há dados a serem mostrados </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </Paper>
    );
  }
}

function mapStateToPros(state: any) {
  const bs = state.orbita.Dashboard.bestsellers || [];
  return {
    isFetching: state.orbita.Dashboard.bestsellers.isFetching,
    producer: bs && bs.producer,
    coproducer: bs && bs.coproducer,
    affiliate: bs && bs.affiliate,
  };
}

export default connect(mapStateToPros)(styles(DoughnutChart));
